import {createMicrositeGatsbyWrapper} from 'microsites/core/chatMicrosite/gatsby/createMicrositeGatsbyWrapper';
import {DEFAULT_LANGUAGE_ID} from 'microsites/core/chatMicrosite/translations/utils/DEFAULT_LANGUAGE_ID';
import {languageSelectorTranslationDefinition} from './src/components/languageSelector/languageSelectorTranslationDef';
import {CHATIWI_DEFAULT_LOCALE} from './src/components/localeLoaders';
import {ChatiwiMicrositeProvider} from './src/micrositeConfig';

const defaultLanguageSelectorTranslation = languageSelectorTranslationDefinition.syncLoaders[CHATIWI_DEFAULT_LOCALE]();
const defaultLanguageSelectorEnglishTranslation = languageSelectorTranslationDefinition.syncLoaders[DEFAULT_LANGUAGE_ID]();

export const wrapRootElement = createMicrositeGatsbyWrapper(ChatiwiMicrositeProvider, CHATIWI_DEFAULT_LOCALE, {
  languageSelectorTranslation: defaultLanguageSelectorTranslation,
  languageSelectorEnglishTranslation: defaultLanguageSelectorEnglishTranslation,
});
